import React from 'react'

import { Title, Detail, Container, TextContainer, Img } from './style'

function Service({ title, detail, img }) {
  return (
    <Container>
      <Img src={img} />
      <TextContainer>
        <Title>{title}</Title>
        <Detail>{detail}</Detail>
      </TextContainer>
    </Container>
  )
}

export default Service
